





















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User, Info, Device} from '@/types/core';

import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue';
import LoraWanUpdateView from '@/components/LoraWanUpdateView.vue';
import CustomSectionHeader from '@/components/CustomSectionHeader.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import { curCoreClient, CoreClient } from '@/services/CoreClient';
import { Subscription, Delivery } from '@/types/core-push';
import DeliveryRow from "@/components/subscriptions/DeliveryRow.vue";
import DeliveryRowMobile from "@/components/subscriptions/DeliveryRowMobile.vue";

@Component({
  components:{
    VueError,
    Loading,
    LoraWanUpdateView,
    CustomSectionHeader,
    TimestampAgo,
    DeliveryRow,
    DeliveryRowMobile,
  }
})
export default class DeliveryList extends Vue {

  @Prop({ default: () => {},  type: Object}) sub!:Subscription;

  error:string = '';
  httpBusy:boolean = false;
  offset = 0;
  dbDeliveryList:Delivery[] = [];
  deliveryList:Delivery[] = [];
  
  showLoading:boolean = false;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
    
  async mounted() {
    
    this.loadDeliveries();
  }

  async loadDeliveries() {

    this.showLoading = true;
    this.error = '';

    const reply = await this.coreClient.getSubDeliveries({subId: this.sub.subscriptionId, limit: 200});

    this.showLoading = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.error = `Unable to retrieve latest deliveries for subscription ${this.sub.subscriptionId}: ${reply.errorMsg}`;

    this.dbDeliveryList = reply.deliveryList!;

    this.offset = 0;
    this.refreshDeliveryList();
  }

  refreshDeliveryList() {
    this.deliveryList = this.dbDeliveryList.slice(this.offset, this.offset+50);
  }

  goBack() {
    this.offset+=50;
    this.refreshDeliveryList();
  }

  goForward() {
    this.offset-=50;
    this.refreshDeliveryList();
  }

  get showNav() { 
    return !this.showLoading && this.deliveryList.length > 0;
  }

  get showItemList() {
    return !this.showLoading && this.deliveryList.length > 0;
  }

  get showNoDeliveries() {
    return !this.showLoading && this.deliveryList.length === 0;
  }

  get olderItemsEnabled() {
    return this.dbDeliveryList.length > 50 && (this.offset + 50) < this.dbDeliveryList.length;
  }

  get newerItemsEnabled() {
    return this.dbDeliveryList.length > 50 && this.offset > 0;
  }

}

